const routesText = [
  {
    heading: "Routes",
  },
  {
    heading: "Kryptys",
  },
  {
    heading: "Kierunki",
  },
];

export default routesText;
